<template>
  <div id="standing" v-if="table.length > 0">
    <table id="table" cellspacing="0" cellspadding="0">
      <tr class="headers">
        <th class="name" colspan="3">
          {{ $t("miclive.competition.scoreboard") + (name ? " " + $t("miclive.standing.group") + " " + name : '') }}
        </th>
        <th class="col">PJ</th>
        <th class="col">PG</th>
        <th class="col">PE</th>
        <th class="col">PP</th>
        <!-- <th class="col">GF</th>
        <th class="col">GC</th> -->
        <th class="col">DIF</th>
        <th class="col">PT</th>
      </tr>
      <tr
        class="item"
        v-for="(position, index) in table"
        :class="{ headers: position.type == 'groups' }"
      >
        <td class="col pos">
          <span class="col pos">{{ position.position }}</span>
        </td>

        <td class="col shield">
          <cld-image :publicId="position.shield" type="fetch" loading="lazy">
            <cld-transformation
              height="100"
              radius="3"
              crop="fill"
              fetchFormat="auto"
            />
          </cld-image>
        </td>
        <td class="name">{{ position.name }}</td>

        <td class="col">{{ position.games }}</td>
        <td class="col">{{ position.wins }}</td>
        <td class="col">{{ position.draws }}</td>
        <td class="col">{{ position.losts }}</td>
        <td class="col">{{ position.goals_f - position.goals_a }}</td>

        <td class="col b">{{ position.points }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "Standings",
  props: {
    table: Object,
    name: String
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    load() {}
  },
  created() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
#standing {
  #table {
    width: 100%;
    max-width: 1000px;

    margin: 0 auto;

    td {
      padding: 7px 5px;
      border-bottom: 2px solid #eee;
    }
    th {
      padding: 10px 5px;
      font-family: $font-title;
      font-size: 12px;
      text-align: left;
    }
    tr {
      background-color: #fff;
      border-radius: 4px;
      &.headers {
        background-color: unset;
      }
    }

    .item {
      .col {
        &.pos {
          color: $main-color;
          font-family: $font-title;
          width: 20px;
        }

        &.shield {
          width: 30px;
          text-align: center;
          img {
            height: 30px;
          }
        }

        &.b {
          font-family: AvantGarde;
        }
      }

      .name {
        font-size: 12px;
        // font-family: $font-title;
        text-align: left;
        width: 50%;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .team {
        .name {
          padding-top: 20px;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
}

// @media only screen and (max-width: 600px) {
//   #standing {
//     #table {
//       tr {
//       }

//       td {
//         padding: 2px 4px;
//         font-size: 12px;
//       }

//       .headers {
//         th {
//           padding: 5px;
//           font-size: 12px;
//         }

//         .name {
//           font-size: 16px;
//         }
//       }

//       .item {
//         .col {
//           &.pos {
//           }

//           &.shield {
//             width: 40px;
//             text-align: center;

//             img {
//               height: 30px;
//             }
//           }

//           &.b {
//           }
//         }

//         .name {
//           width: 30%;
//         }

//         .team {
//           .name {
//             padding-top: 20px;
//           }
//         }
//       }
//     }
//   }
// }
</style>
